import { GridColumns as VisxGridColumns } from '@visx/grid';
import { AllGridColumnsProps } from '@visx/grid/lib/grids/GridColumns';

import { GridLines } from './GridLines.js';
import { shouldHighlightZeroLine } from './utils/should-highlight-zero-line.js';
import type { AnyScale } from '../../types/scales.js';
import { isBandScale } from '../../utils/detect-scale.js';

export type GridColumnsProps = {
  highlightZeroLine?: boolean;
  ticks?: number[];
} & AllGridColumnsProps<AnyScale>;

export const GridColumns = ({
  scale,
  highlightZeroLine = true,
  ticks,
  ...restProps
}: GridColumnsProps) => {
  if (ticks) {
    const typedScale = scale as (value: number) => number | undefined;
    const lines = ticks.map((tick, index) => ({
      from: { x: Math.max(0, typedScale(tick) ?? 0), y: 0 },
      to: { x: Math.max(0, typedScale(tick) ?? 0), y: restProps.height },
      index,
    }));

    return (
      <GridLines
        lines={lines}
        highlightAccessor={(from, to) =>
          highlightZeroLine &&
          !isBandScale(scale) &&
          shouldHighlightZeroLine(from, to, scale)
        }
      />
    );
  }

  return (
    <VisxGridColumns scale={scale} {...restProps}>
      {({ lines }) => (
        <GridLines
          lines={lines}
          highlightAccessor={(from, to) =>
            highlightZeroLine &&
            !isBandScale(scale) &&
            shouldHighlightZeroLine(from, to, scale)
          }
        />
      )}
    </VisxGridColumns>
  );
};
